import { render, staticRenderFns } from "./admin-set.vue?vue&type=template&id=3304600c"
import script from "./admin-set.vue?vue&type=script&lang=js"
export * from "./admin-set.vue?vue&type=script&lang=js"
import style0 from "./admin-set.vue?vue&type=style&index=0&id=3304600c&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports